const STARTS_WITH_VOWEL_PATTERN = /^[aeiou]/i;

function startsWithVowel(string: string) {
  return STARTS_WITH_VOWEL_PATTERN.test(string);
}

export default startsWithVowel;
